<header class="vo-topbar">
  <div class="vo-topbar__inner">
    <a href="https://www.vergleichsofferten.ch/" target="_blank" rel="noopener" class="vo-topbar__logo">
      <img src="/assets/img/brand.svg" alt="Vergleichsofferten" width="100" height="34">
    </a>

    <ul class="vo-topbar__trust">
      <li class="vo-trust-item">
        <app-icon name="circle-check" [size]="16"/>
        100% kostenlos &amp; unverbindlich
      </li>
      <li class="vo-trust-item">
        <svg class="vo-flag" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <rect width="24" height="24" fill="#D52B1E"/>
          <path d="M10.5 5h3v14h-3z" fill="#fff"/>
          <path d="M5 10.5h14v3H5z" fill="#fff"/>
        </svg>
        nur Schweizer Unternehmen
      </li>
      <li class="vo-trust-item">
        <app-icon name="trending-down" [size]="16"/>
        Bis zu 40 % sparen
      </li>
    </ul>
  </div>
</header>
